import { Switch, Route, Redirect } from "react-router-dom";
import LoginPage from "../pages/Login/LoginPage";
import ForgotPasswordPage from "../pages/ForgotPassword/ForgotPasswordPage";
import SignUpPage from "../pages/SignUpPage/SignUpPage";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import UserConfirmationPage from "../pages/UserConfirmation/UserConfirmationPage";

const Public = ({ setUser }) => {
  return (
    <Switch>
      <Redirect exact from="/" to="/login" />
      <Route exact path="/login" render={() => <LoginPage setUser={setUser} />} />
      <Route exact path="/user-confirm" render={() => <UserConfirmationPage />} />
      <Route exact path="/forgot-password" component={ForgotPasswordPage} />
      <Route exact path="/change-password" component={ChangePassword} />
      <Route exact path="/signup" component={SignUpPage} />
      <Route render={() => <Redirect to="/login" />} />
    </Switch>
  );
};
export default Public;
